module.exports = __webpack_public_path__ + "img/bell.19b643e1.svg";